import  {Component, OnInit} from '@angular/core';
import {Observable, switchMap} from "rxjs";
import {Blog} from "../../../../models/blog";
import {ActivatedRoute} from "@angular/router";
import {Meta, Title} from "@angular/platform-browser";
import {DatePipe} from "@angular/common";
import {BlogService} from "../service/blog.service";
import {environment} from "../../../../environments/environment.production";
import {formatDate, setCanonicalUrl, setSocialMeta, setStructuredData} from "../../../../services/util/util";
import {ShopService} from "../../../shop/service/shop.service";
import {Product} from "../../../../models/product";
import {Link} from "../../../../models/link";
import {FBQ} from "../../../../models/fbq";
import {Carousel, initTE} from "tw-elements";

declare let fbq: FBQ;

@Component({
    selector: 'app-blog-detail',
    templateUrl: './blog-detail.component.html',
    styleUrl: './blog-detail.component.css'
})
export class BlogDetailComponent implements OnInit {

    blog!: Observable<Blog>;

    products: Product[] = [];

    links: Link[] = [
        {
            text: "Почетна",
            route: environment.navigation.home,
        },
        {
            text: "Блог",
            route: environment.navigation.blog,
        }]

    constructor(private route: ActivatedRoute,
                private blogService: BlogService,
                private meta: Meta,
                private titleService: Title,
                protected datePipe: DatePipe,
                protected shopService: ShopService
    ) {
    }

    ngOnInit(): void {
        initTE({Carousel});
        this.blog = this.route.paramMap.pipe(
            switchMap(params => {
                const slugAndId = params.get('slugAndId')!;

                let id: number;

                if (slugAndId.includes('-')) {
                    id = +slugAndId.split('-').pop()!;
                } else {
                    id = +slugAndId;
                }
                return this.blogService.getBlogById(id);
            })
        );

        this.blog.subscribe(blog => {
            // this.updateLinks(product.category);
            // The route is /blogs/:slugAndId - the old "/blog/" segment pointed Google at a page that does not exist.
            const canonicalUrl = environment.domain.frontend + environment.navigation.blog + '/' + (blog?.slug ? blog?.slug + '-' + blog?.id : blog?.id);
            setCanonicalUrl(canonicalUrl);
            this.setTitle(blog);
            this.setMetaDescription(blog);
            this.setMetaKeywords(blog);
            setStructuredData('blog-structured-data', {
                "@context": "https://schema.org/",
                "@type": "BlogPosting",
                "headline": blog.title,
                "description": blog.summary,
                "image": blog.mainImage ? [blog.mainImage] : [],
                "datePublished": blog.publishDate,
                "author": {"@type": "Person", "name": blog.author?.name},
                "publisher": {"@type": "Organization", "name": "Алое вера гел", "url": environment.domain.frontend},
                "mainEntityOfPage": canonicalUrl
            });
            setSocialMeta(this.meta, {
                title: blog.title,
                description: blog.summary,
                url: canonicalUrl,
                image: blog.mainImage,
                type: 'article'
            });
            this.shopService.getProductsByIds(blog.productAdIds).subscribe((products) => this.products = products)
            fbq('track', 'ViewContent', {
                content_name: blog?.title,
                content_ids: [`BLOG_${blog.id}`],
                content_category: blog?.category,
                content_type: 'article',
            });
        });

    }

    setTitle(blog: Blog) {
        this.titleService.setTitle(blog.title);
    }

    setMetaDescription(blog: Blog) {
        const metaDescription = (blog.summary.length > 160) ? blog.summary.substring(0, 157) + '...' : blog.summary;

        this.meta.updateTag({name: 'description', content: metaDescription});
    }

    private setMetaKeywords(blog: Blog): void {
        const keywords = blog.keywords?.join(', ') ?? '';

        this.meta.updateTag({name: 'keywords', content: keywords});
    }

    protected readonly formatDate = formatDate;
}